<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <form-select v-model="query.tag" id="tag" label="參數類型" @change="load">
                    <div is="option" v-for="o in tags" :key="o.key" :value="o.key">{{o.value}}</div>
                </form-select>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Key</th>
                            <th>Value</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.Key">
                        <td data-th="Key">{{item.Key}}</td>
                        <td data-th="Value">{{item.Value}}</td>
                        <td>
                            <b-button variant="danger" @click="del(item.Key)">刪除</b-button>
                        </td>
                    </tr>
                    <tr>
                        <td data-th="Key">
                            <input v-model="temp.Key" type="text" class="form-control" />
                        </td>
                        <td data-th="Value">
                            <input v-model="temp.Value" type="text" class="form-control" />
                        </td>
                        <td>
                            <div class="form-group">
                                <b-button variant="primary" @click="save">儲存</b-button>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </page-main>
</template>

<script>
    let api = '/api/parameterset/';
    let tags = [{ key: 'CommunityProperty', value: '社團屬性' }, { key: 'CommunityJob', value: '社團職務' }, /*{ key: 'CommunityActivity', value: '社團活動屬性' }*/];

    export default {
        name: 'g4parameter',
        data: function () {
            return {
                tags: tags,
                query: { tag: 'CommunityProperty' },
                tableData: { count: 0, value: [] },
                temp: { Key: '', Value: '' },
                loading: false, saveing: false,
            }
        },
        created: function () {
            this.load();
        },
        methods: {
            load: function () {
                this.loading = true;
                this.$http({ method: 'get', url: api + "/Get/" + this.query.tag })
                    .then(res => this.tableData = res.data)
                    .finally(() => this.loading = false);
            },
            save: function () {
                this.saveing = true;

                this.temp.Type = this.query.tag;
                this.$http({ method: 'put', url: api + "/Put/" + this.query.tag, data: this.temp })
                    .then(() => {
                        this.load();
                        this.temp = { Key: '', Value: '' };
                    })
                    .finally(() => this.saveing = false);
            },
            del: function (Key) {
                this.$http({ method: 'delete', url: api + "Delete/" + Key + "?Type=" + this.query.tag })
                    .then(() => {
                        this.load();
                    })
            },
        }
    };
</script>

<style>
</style>